import { Image } from "./image";
import { Link } from "react-router-dom";

export const Calltoaction = (props) => {
    return (
        <div className='text-center cta'>
            <div className='container'>
                <div className='row mt-2 mb-2'>
                    <div className='col-xs-12 col-md-10 col-md-offset-1'>
                        <h2 className="cto1">Improve shift productivity and reduce team friction</h2>
                        <p>Crew Coin helps reinforce expectations, boost follow-through, and reduce tense manager-employee confrontations during busy shifts.</p>
                    </div>
                </div>
                <div className='row'>
                    <div className='portfolio-items'>
                        <div className='col-xs-12 intro-text cc-cta-button-wrap'>
                            <Link to='/signup'>
                                <div
                                    className='btn btn-custom2 page-scroll'
                                >

                                    Start free trial

                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}